module.exports = __webpack_public_path__ + "img/10.ce0b86a4.jpg";